import { render, staticRenderFns } from "./MovementSection.vue?vue&type=template&id=9ec4f9b2&"
import script from "./MovementSection.vue?vue&type=script&lang=js&"
export * from "./MovementSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports